import React, {
  Component
} from "react";
import {
  Input,
  Button,
  Alert
}
from "@maxmilhas/hangar-components-atomic/public";
import {
  checkoutCredentials,
} from "../../../../shared/utils";
import {
  confirmPasswordInCancellation
} from "../../../../shared/requests-api";
import BaseCancellationModal from "../base-components/BaseCancellationModal";

export default class PasswordModal extends Component {
  constructor() {
    super();
    this.state = {
      password: null,
      validating: false,
      error: false
    };
    this.submit = this.submit.bind(this);
  }

  change = event => {
    this.setState({
      password: event.target.value
    });
  }

	submit = async () => {
    this.setState({
      validating: true
    });
    const { password } = this.state;
    const loginToken = checkoutCredentials().au;
    const { token, order } = this.props;
    const response = await confirmPasswordInCancellation(loginToken, token, password, order.code).catch(err => {
      this.setState({
        validating: false,
        error: true
      });
      return;
    });

		return this.props.onSubmit({
      loginToken: loginToken,
      orderCode: order.code,
      token: response.data.token
    });
	}

	render = () => {
		return (
      <BaseCancellationModal open={this.props.open}>
				<div className="modal-header-wrapper">
					<button onClick={() => this.props.closeModal()} className="close-button">
						<i className="icon-close" />
					</button>

					<p className="lead">Confirme sua senha:</p>
					<p>Insira sua senha para confirmar a solicitação.</p>
				</div>
				<div className="tingle-modal-box__content">
					<div className="row">
						{this.state.error && <div className="col-xs-16 col-md-16">
              <Alert type="danger">
                Erro ao confirmar senha, por favor tente novamente!
              </Alert>
            </div>}
						<div className="col-xs-16 col-md-16">
              <Input 
                type="password"
                placeholder="Digite sua senha"
                shadow={0}
                onChange={this.change}
                />
            </div>
						<div className="col-xs-16 col-md-16">
							<Button
								disabled={this.state.validating}
                id="button_confirm_password"
                outline={0}
								onClick={() => {
									this.submit();
								}}
							>
								{ this.state.validating ? 'Confirmando...' : 'OK' }
							</Button>
						</div>
					</div>
				</div>
      </BaseCancellationModal>
		);
	}
}
